import { MessageType } from 'types/message'
import { Action, Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { db, FirebaseTimestamp } from 'firebase/index'

const saveMessage = (message: MessageType, id?: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    const now = FirebaseTimestamp.now()
    message.updated_at = now
    if (!id) {
      message.created_at = now
    }
    const ref = id ? db.collection('messages').doc(id) : db.collection('messages').doc()

    return ref
      .set(message, { merge: true })
      .then(() => {
        dispatch(hideLoadingAction())
      })
      .catch((error) => {
        console.error(error)
        dispatch(hideLoadingAction())
      })
  }
}

export default saveMessage
